/**
 * SYNKD Focus Homepage - external JS (CSP-safe, no inline scripts)
 */
(function () {
  function initHomepage(root) {
    if (!root || root.getAttribute('data-sfh-ready') === 'true') return;
    root.setAttribute('data-sfh-ready', 'true');

    var faqItems = root.querySelectorAll('.sfp-faq-item');
    faqItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          faqItems.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        }
      });
    });

    var filterToggle = root.querySelector('[data-reviews-filter-toggle]');
    var filterPanel = root.querySelector('[data-reviews-filters]');
    var reviewCards = Array.prototype.slice.call(
      root.querySelectorAll('[data-reviews-list] .sfp-review-card')
    );
    var moreBtns = root.querySelectorAll('[data-reviews-more]');
    var desktopReviewsMq = window.matchMedia('(min-width: 990px)');
    var configuredInitial = parseInt(root.getAttribute('data-reviews-initial') || '4', 10) || 4;
    var activeStarFilter = 'all';
    var showingAllReviews = false;

    function getInitialReviewCount() {
      if (desktopReviewsMq.matches) return Math.max(configuredInitial, 4);
      if (window.matchMedia('(min-width: 768px)').matches) return Math.min(configuredInitial, 3);
      return Math.min(configuredInitial, 2);
    }

    function setActiveFilterUI(stars) {
      root.querySelectorAll('[data-filter-stars]').forEach(function (el) {
        var isActive = el.getAttribute('data-filter-stars') === String(stars);
        el.classList.toggle('is-active', isActive);
        if (el.classList.contains('sfp-reviews-bar-row')) {
          el.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
      });
    }

    function applyReviewFilter(stars) {
      activeStarFilter = String(stars);
      setActiveFilterUI(activeStarFilter);
      var initialReviewCount = getInitialReviewCount();

      var visibleIndex = 0;
      reviewCards.forEach(function (card) {
        var cardStars = String(card.getAttribute('data-review-stars') || '');
        var match = activeStarFilter === 'all' || cardStars === activeStarFilter;
        card.classList.toggle('is-filtered-out', !match);

        if (!match) {
          card.classList.add('is-hidden');
          return;
        }

        if (activeStarFilter === 'all' && !showingAllReviews && visibleIndex >= initialReviewCount) {
          card.classList.add('is-hidden');
        } else {
          card.classList.remove('is-hidden');
        }
        visibleIndex += 1;
      });

      moreBtns.forEach(function (moreBtn) {
        if (activeStarFilter !== 'all') {
          moreBtn.hidden = true;
        } else {
          moreBtn.hidden = showingAllReviews || reviewCards.length <= initialReviewCount;
        }
      });
    }

    if (filterToggle && filterPanel) {
      filterToggle.addEventListener('click', function () {
        var open = filterPanel.hasAttribute('hidden');
        if (open) filterPanel.removeAttribute('hidden');
        else filterPanel.setAttribute('hidden', '');
        filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    root.querySelectorAll('[data-filter-stars]').forEach(function (el) {
      el.addEventListener('click', function () {
        var stars = el.getAttribute('data-filter-stars');
        if (stars === activeStarFilter && stars !== 'all') applyReviewFilter('all');
        else applyReviewFilter(stars);
        if (filterPanel && el.classList.contains('sfp-reviews-bar-row')) {
          filterPanel.removeAttribute('hidden');
          if (filterToggle) filterToggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    moreBtns.forEach(function (moreBtn) {
      moreBtn.addEventListener('click', function () {
        showingAllReviews = true;
        applyReviewFilter(activeStarFilter);
      });
    });

    if (reviewCards.length) applyReviewFilter('all');
    if (desktopReviewsMq.addEventListener) {
      desktopReviewsMq.addEventListener('change', function () {
        if (!showingAllReviews) applyReviewFilter(activeStarFilter);
      });
    }

    var marquee = root.querySelector('[data-community-marquee]');
    var marqueeTrack = root.querySelector('[data-community-track]');
    if (marquee && marqueeTrack) {
      var pause = function () {
        marqueeTrack.style.animationPlayState = 'paused';
      };
      var play = function () {
        marqueeTrack.style.animationPlayState = 'running';
      };
      marquee.addEventListener('mouseenter', pause);
      marquee.addEventListener('mouseleave', play);
      marquee.addEventListener('focusin', pause);
      marquee.addEventListener('focusout', play);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        marqueeTrack.style.animation = 'none';
      }
    }

    var statsRoot = root.querySelector('[data-sfh-stats]');
    if (statsRoot && 'IntersectionObserver' in window) {
      var animated = false;
      var values = statsRoot.querySelectorAll('[data-count-to]');
      var animateCount = function (el) {
        var target = parseFloat(el.getAttribute('data-count-to')) || 0;
        var suffix = el.getAttribute('data-count-suffix') || '';
        var duration = 1200;
        var start = null;
        var step = function (ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || animated) return;
            animated = true;
            values.forEach(animateCount);
            observer.disconnect();
          });
        },
        { threshold: 0.35 }
      );
      observer.observe(statsRoot);
    } else if (statsRoot) {
      statsRoot.querySelectorAll('[data-count-to]').forEach(function (el) {
        el.textContent = (el.getAttribute('data-count-to') || '0') + (el.getAttribute('data-count-suffix') || '');
      });
    }

    /*
      One shared [data-pdp-form] master form - cart drawer only binds the first match.
      Every bestseller ATC button sets variant id on that form and submits it.
    */
    bindBestsellerAtc(root);

    /* Let shared cart (synkd-clearmind-cart) re-scan forms after homepage init */
    try {
      document.dispatchEvent(new CustomEvent('synkd:pdp-forms:ready', { detail: { root: root } }));
    } catch (e) {}
  }

  function openCartDrawerFallback() {
    var eventNames = [
      'cart:open',
      'cart:refresh',
      'cart:updated',
      'synkd:cart:open',
      'synkd:cart:refresh',
      'ajaxCart:updated'
    ];
    eventNames.forEach(function (name) {
      try {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { open: true } }));
      } catch (e) {}
    });

    var drawer = document.querySelector(
      '[data-cart-drawer], cart-drawer, #CartDrawer, #cart-drawer, .cart-drawer, [data-synkd-cart], .synkd-cart-drawer'
    );
    if (drawer) {
      drawer.classList.add('is-open', 'active', 'open');
      drawer.setAttribute('aria-hidden', 'false');
      if (typeof drawer.open === 'function') {
        try {
          drawer.open();
        } catch (e) {}
      }
    }

    var trigger = document.querySelector(
      '[data-cart-open], [data-open-cart], [aria-controls="CartDrawer"], [aria-controls="cart-drawer"], .js-open-cart'
    );
    if (trigger) {
      try {
        trigger.click();
      } catch (e) {}
    }
  }

  function ajaxAddVariant(variantId, qty, done) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(qty) || 1 }),
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        openCartDrawerFallback();
        if (done) done(true);
      })
      .catch(function () {
        if (done) done(false);
      });
  }

  function bindBestsellerAtc(root) {
    var master =
      root.querySelector('[data-sfh-atc-master]') ||
      document.querySelector('[data-sfh-atc-master]');
    var idInput = master ? master.querySelector('[data-sfh-atc-id], input[name="id"]') : null;
    var qtyInput = master ? master.querySelector('[data-sfh-atc-qty], input[name="quantity"]') : null;
    var buttons = root.querySelectorAll('[data-sfh-atc][data-variant-id]');

    if (master && !master.hasAttribute('data-pdp-form')) {
      master.setAttribute('data-pdp-form', '');
    }

    buttons.forEach(function (btn) {
      if (btn.getAttribute('data-sfh-atc-bound') === 'true') return;
      btn.setAttribute('data-sfh-atc-bound', 'true');

      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        if (master && idInput) {
          idInput.value = variantId;
          if (qtyInput) qtyInput.value = '1';
          btn.setAttribute('disabled', 'disabled');
          window.setTimeout(function () {
            btn.removeAttribute('disabled');
          }, 1200);

          try {
            if (typeof master.requestSubmit === 'function') master.requestSubmit();
            else master.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          } catch (err) {
            ajaxAddVariant(variantId, 1);
          }
          return;
        }

        ajaxAddVariant(variantId, 1);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-sfh-root]').forEach(initHomepage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-sfh-root]');
    if (root) {
      root.removeAttribute('data-sfh-ready');
      initHomepage(root);
    }
  });
})();
